export const Urls = "https://api-multiverse.taction.in/api/api/v1/";

export const mainUrl = "http://20.204.68.232:81/";
